import React from "react";
import Table from "../../../../../components/Table";
import { useLocalization } from "../../../../../../context/LocalizeContextProvider";
import moment from "moment";

export default function CpptSummary({ assessmentData = [] }) {
  const localize = useLocalization();

  const columns = [
    {
      label: localize.getText("subjective"),
      key: "subjective",
      style: { minWidth: "200px" },
    },
    {
      label: localize.getText("objective"),
      key: "objective",
      style: { minWidth: "200px" },
    },
    {
      label: localize.getText("assessment"),
      key: "assessment",
      style: { minWidth: "200px" },
    },
    {
      label: localize.getText("plan"),
      key: "plan",
      style: { minWidth: "200px" },
    },
    { label: localize.getText("profession"), key: "profession" },
    { label: localize.getText("updatedBy"), key: "updatedBy" },
    { label: localize.getText("updatedDate"), key: "updatedDate" },
  ];

  const getAssessmentText = (assessment) => {
    if (!assessment) return "";

    try {
      const data =
        typeof assessment === "string" ? JSON.parse(assessment) : assessment;
      return Array.isArray(data)
        ? data.map((item) => item.label || item.value).join(", ")
        : assessment;
    } catch {
      return assessment;
    }
  };

  const processAssessmentData = () => {
    if (!assessmentData || !Array.isArray(assessmentData)) {
      return [];
    }

    return assessmentData
      .map((assessment) => {
        const getProfessionDisplay = (role) => {
          switch (role?.toLowerCase()) {
            case "doctor":
              return "Dokter";
            case "nurse":
              return "Perawat/Terapis";
            case "pharmacy":
              return "Farmasi";
            default:
              return role || "Unknown";
          }
        };

        const formattedDate = assessment.updated_at
          ? moment(assessment.updated_at, "YYYY-MM-DDTHH:mm:ss.SSSZ").format(
              "DD MMMM YYYY, HH:mm"
            )
          : "";

        return {
          id: assessment.id,
          subjective: assessment.subjective || "-",
          objective: assessment.objective || "-",
          assessment: getAssessmentText(assessment.assessment),
          plan: assessment.plan || "-",
          profession: getProfessionDisplay(assessment.role),
          updatedBy: assessment.updated_by || "-",
          updatedDate: formattedDate,
          rawUpdatedAt: assessment.updated_at,
        };
      })
      .sort((a, b) => new Date(b.rawUpdatedAt) - new Date(a.rawUpdatedAt));
  };

  const cpptData = processAssessmentData();

  const getLatestUpdateTime = () => {
    if (cpptData.length > 0) {
      return cpptData[0].updatedDate;
    }

    return null;
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 16,
        padding: 16,
        borderRadius: 8,
        border: "1px solid #E5E5E5",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <p
          style={{
            margin: 0,
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          Catatan Perkembangan Pasien Terintegrasi
        </p>
        {getLatestUpdateTime() && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <i className="far fa-clock" style={{ fontSize: 14 }}></i>
            <p style={{ margin: 0, fontSize: 12, fontWeight: 500 }}>
              {getLatestUpdateTime()}
            </p>
          </div>
        )}
      </div>

      <Table
        columns={columns}
        totalShow={cpptData.length}
        totalPage={1}
        totalEntries={cpptData.length}
        noPagination
      >
        {cpptData.map((item, index) => (
          <tr key={index}>
            <td>{item.subjective}</td>
            <td>{item.objective}</td>
            <td>{item.assessment}</td>
            <td>{item.plan}</td>
            <td>{item.profession}</td>
            <td>{item.updatedBy}</td>
            <td>{item.updatedDate}</td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
